package ui.license

import androidx.compose.runtime.*
import androidx.compose.ui.text.input.*
import io.*
import kotlinx.coroutines.*
import org.jetbrains.compose.resources.*
import ssoft.frontend.generated.resources.*
import tk.mallumo.compose.navigation.viewmodel.*
import tk.mallumo.utils.*

@VM
class LicenseListingVM : NavigationViewModel() {

    private lateinit var scopeUi: LicenseListingScope

    var state by mutableDataState<LicenseListingScope.Wrapper>()
        private set


    val searchFiled = mutableStateOf(TextFieldValue(""))

    sealed interface Action {
        //        class New(val item: Io.ListingServer.Item) : Action
        companion object {

            @Composable
            fun rememberAction(vm: LicenseListingVM): (Action) -> Unit {
                return remember {
                    { act ->

                    }
                }
            }
        }
    }


    fun init(scopeUi: LicenseListingScope) {
        this.scopeUi = scopeUi
        if (state !is DataState.Result) {
            state = DataState.Loading()
        }

        scope.launch {
            runCatching {
                state = DataState.Result(
                    LicenseListingScope.Wrapper(
                        Repository.api.license.listing()
                    )
                )
            }.onFailure {
                it.printStackTrace()
                state = DataState.Error(getString(Res.string.err_connection_interrupted))
            }
        }
    }

    override fun onRelease() {
        state.entry?.release()
        state = DataState.Idle()
    }

}
